import React from 'react'

import { checkPermission, checkTranslation, chooseWallpaper, getObject, getPermissionObject, imageAddress, setObject, translate } from "../utils/useful";

import SelectInput from './inputs/SelectInput';
import Collapsible from 'react-collapsible';
import FilterEditorInput from './inputs/FilterEditorInput';
import HelpButton from './HelpButton';
import SelectListInput from './inputs/SelectListInput';
import SwitchInput from './inputs/SwitchInput';
import { collectionPermissions, stagePermissions } from '../variables/PermissionsData';

class CollectionPermissionsView extends React.Component {

    state = {

        currentType: 'admins',
        tabsView: {},
        // currentTab: 'view',
        viewAndEditHeaders: {
            records: { key: 'records', title: '{{lang}}Records', main: true },
            fields: { key: 'fields', title: '{{lang}}Fields', main: true },
        },

        removeHeaders: {
            records: { key: 'records', title: '{{lang}}Records', main: true },
            // fields: { key: 'fields', title: '{{lang}}Fields', main: true },
        },

        manageHeaders: {
            views: {
                title: "{{lang}}Dynamic Views", horizontal: true, key: 'views', permissions: {
                    view: { key: 'view', title: '{{lang}}View', main: true },
                    create: { key: 'create', dependancy: 'view', title: '{{lang}}Create', main: true },
                    edit: { key: 'edit', dependancy: 'view', title: '{{lang}}Edit', main: true },
                    remove: { key: 'remove', dependancy: 'view', title: '{{lang}}Remove', main: true },
                }
            },

            actions: {
                title: "{{lang}}Dynamic actions", horizontal: true, key: 'actions', permissions: {
                    view: { key: 'view', title: '{{lang}}View', main: true },
                    create: { key: 'create', dependancy: 'view', title: '{{lang}}Create', main: true },
                    edit: { key: 'edit', dependancy: 'view', title: '{{lang}}Edit', main: true },
                    remove: { key: 'remove', dependancy: 'view', title: '{{lang}}Remove', main: true },
                }
            },

            general: {
                title: "{{lang}}General", key: 'general', permissions: {
                    editInfo: { key: 'editInfo', title: '{{lang}}Edit collection information', main: true },
                    viewLog: { key: 'viewLog', title: '{{lang}}View activity log', main: true },
                    conditionalFormat: { key: 'conditionalFormat', title: '{{lang}}Manage conditional formating', main: true },
                }
            },

        }


    }

    componentDidMount() {
        this.createTabPermissions()
    }


    componentDidUpdate(prevProps) {
        if (prevProps.permissionsObject != this.props.permissionsObject) {
            this.createTabPermissions()
        }
    }


    createTabPermissions = () => {

        let frame = this.props.frame
        let id = frame._id ?? frame.id
        let admin = this.props.admin

        let tabPermission = {}
        let tabRecordsPermission = {}
        let tabFieldsPermission = {}
        let viewFieldsPermission = {}
        let framePermission

        if (this.props.permissionsObject && this.props.permissionsObject[admin?.id]) {

            framePermission = this.props.permissionsObject[admin?.id][id]

            tabPermission = { ...getPermissionObject(framePermission, this.state.currentTab) }

            tabRecordsPermission = { ...getPermissionObject(framePermission, (this.state.currentTab + '.records'), null, true) }
            tabFieldsPermission = { ...getPermissionObject(framePermission, (this.state.currentTab + '.fields'), null, true) }
            viewFieldsPermission = { ...getPermissionObject(framePermission, ('view.fields'), null, true) }


        }

        this.setState({ tabPermission, tabRecordsPermission, tabFieldsPermission, viewFieldsPermission }, () => {
            let tab = this.state.currentTab
            // this.setState({ currentTab: null }, () => {
            //     this.setState({ currentTab: tab })
            // })
        })
    }




    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }




    changeTabsView = (key) => {

        this.setState({ currentTab: key, tabPermission: null, tabRecordsPermission: null, tabFieldsPermission: null }, () => {
            this.createTabPermissions()
        })
    }


    renderLabel = (framePermission) => {
        return (
            <>
                {framePermission == '*' && (
                    <div className='br-4' style={{ padding: '3px 4px', backgroundColor: 'rgb(0, 205, 116)', color: '#fff' }}>
                        <p className='text-smallest text-bold'>{translate('Full access')}</p>
                    </div>
                )}

                {framePermission == null && (
                    <div className='br-4' style={{ padding: '3px 4px', backgroundColor: 'rgb(238, 80, 80)', color: '#fff' }}>
                        <p className='text-smallest text-bold'>{translate("No access")}</p>
                    </div>
                )}

                {(framePermission != null && framePermission != '*') && (
                    <div className='br-4' style={{ padding: '3px 4px', backgroundColor: '#fc9d03', color: '#fff' }}>
                        <p className='text-smallest text-bold'>{translate("Partial access")}</p>
                    </div>
                )}
            </>
        )
    }

    toggleAdvanced = () => {
        this.setState({ showAdvanced: !this.state.showAdvanced }, () => {
            if (this.state.showAdvanced && this.state.currentTab == null) {
                let advancedTabs = this.props.permissionHeaders?.advancedTabs
                console.log(advancedTabs)
                if (Array.isArray(advancedTabs)) {
                    this.setState({ currentTab: advancedTabs[0]?.key })
                }
            }
        })
    }


    render() {

        let admin = this.props.admin
        let frame = this.props.frame
        let id = frame._id ?? frame.id ?? frame.key


        // console.log(id)
        let permissionHeaders = this.props.permissionHeaders?.permissions
        // let permissionsSections = [{ label: 'access', key: '**fullAccess' }, { label: 'View', key: 'view', dependancy: 'view' }, { label: 'create', key: 'create', dependancy: 'view' }, { label: 'Edit', key: 'edit', dependancy: 'view' }, { label: 'remove', key: 'remove', dependancy: 'view' }, { label: 'manage', key: 'manage' }]
        // let permissionsSections = [{ label: 'View', key: 'view', dependancy: 'view' }, { label: 'create', key: 'create', dependancy: 'view' }, { label: 'Edit', key: 'edit', dependancy: 'view' }, { label: 'remove', key: 'remove', dependancy: 'view' }, { label: 'manage', key: 'manage' }]
        let advancedTabs = this.props.permissionHeaders?.advancedTabs


        // if (this.props.type == 'stage') {

        //     permissionHeaders = stagePermissions.permissions
        //     // permissionsSections = [{ label: 'View', key: 'view', dependancy: 'view' }, { label: 'Edit', key: 'edit', dependancy: 'view' },]
        //     advancedTabs = stagePermissions.advancedTabs

        // }
        // console.log(this.props.permissionsObject)

        // console.log("admin?.id",admin?.id,id)

        let framePermission = (this.props.permissionsObject && this.props.permissionsObject[admin?.id]) ? this.props.permissionsObject[admin?.id][id] : null

        // console.log(framePermission)

        return (

            <>
                {this.props.permissionsObject && permissionHeaders && (

                    <div className={' ' + (this.props.isMain ? ' py-2 ' : '')} style={{ backgroundColor: '#fff', }}>
                        {this.props.isMain && (

                            <div className='flexcb  mb-1 px-3 pb-2 pt-0' style={{ borderBottom: '1px solid #eee' }}>
                                <div className='flexc' >
                                    {/* <SwitchInput header={{ information: {} }} /> */}
                                    <button className='p-0 flexcc' onClick={() => this.props.fullAccessedClicked(frame, this.props.permissionsType)} >
                                        <div className={"checkbox-container position-relative " + ((framePermission && framePermission != '*') ? 'half-mark' : '')} >
                                            <input type="checkbox" checked={framePermission ?? false} />
                                            <span className="checkmark"></span>
                                            <div style={{}} className='position-absolute top-0 left-0 w-100 h-100'>
                                            </div>
                                        </div>
                                    </button>

                                    {/* <div className='br-4 p-1 mld-2 flexcc' style={{ backgroundColor: '#eee' }}>
                                        <img src={'/assets/icons/useful/stack1.png'} width={20} />
                                        </div> */}
                                    <p className='text-bold text-small mb-1 mt-1 mld-2'>{checkTranslation(frame.name)}
                                        {this.props.stage?.name && (<span>| {checkTranslation(this.props.stage?.name)}</span>)}
                                    </p>

                                    {admin.locked && (
                                        <div className=' p-1 mld-0 flexcc ' style={{ opacity: 0.3 }}>
                                            <img src={'/assets/icons/useful/padlock.png'} width={16} />
                                        </div>
                                    )}


                                </div>

                                {this.renderLabel(framePermission)}



                            </div>
                        )}


                        <div className={' flex-wrap ' + (this.props.isMain ? ' pt-2 px-3 mt-2 ' : ' ') + (this.props.permissionHeaders?.horizontal ? ' flexc ' : '')} style={{ borderBottom: '0px solid #eee' }}>
                            {Object.values(permissionHeaders).map((perm, index) => {
                                let fullKey = this.props.parentKey ? (this.props.parentKey + '.' + perm.key) : perm.key
                                let pObject = getPermissionObject(framePermission, fullKey)
                                let textOnBottom = this.props.permissionHeaders.textOnBottom
                                let horizontal = this.props.permissionHeaders?.horizontal
                                // if (this.props.permissionsObject[admin?.id]) {

                                //     pObject = getPermissionObject(framePermission, perm.key)

                                // }

                                return (
                                    // <div className='d-flex flex-column mrd-5 cursor-pointer mb-0 ' onClick={() => { if (perm.key == '**fullAccess') { this.props.fullAccessedClicked(frame) } else { this.props.changeAccess(frame, perm, pObject.value == '*' ? null : '*', permissionHeaders) } }} style={{ minWidth: 35, borderLeft: '0px solid #eee' }} key={perm.key} >
                                    //     <div className=''>
                                    //         <div class="box" >

                                    //             <button className={"checkbox-container position-relative " + ((pObject.value && pObject.value != '*') ? 'half-mark' : '')}  >
                                    //                 <input type="checkbox" checked={pObject.allowed} />
                                    //                 <span className="checkmark"></span>
                                    //                 <div style={{}} className='position-absolute top-0 left-0 w-100 h-100'>
                                    //                 </div>
                                    //             </button>

                                    //         </div>
                                    //     </div>

                                    //     <p className='text-smaller mt-1 text-semibold'>{checkTranslation(perm.title)}</p>
                                    // </div>
                                    <div key={index} className={'' + (horizontal ? ' pb-2 ' : ((!horizontal && perm.permissions) ? ' mb-3 pb-2 ' : ' mb-2'))} style={{ minWidth: 50, borderBottom: horizontal ? '' : ((!horizontal && perm.permissions) ? Object.values(permissionHeaders).length - 1 == index ? '0px solid #f2f2f2' : '1px solid #f2f2f2' : '') }}>

                                        <button className={'  mrd-4 ' + (textOnBottom ? '  ' : ' mb-2 flexc')} onClick={() => { this.props.changeAccess(frame, perm, pObject.value == '*' ? null : '*', [...this.props.previousHeaders, permissionHeaders], this.props.parentKey) }}>

                                            <div className={"checkbox-container position-relative " + ((pObject.value && pObject.value != '*') ? 'half-mark' : '')}  >
                                                <input type="checkbox" checked={pObject.allowed} />
                                                <span className="checkmark"></span>
                                                <div style={{}} className='position-absolute top-0 left-0 w-100 h-100'>
                                                </div>
                                            </div>
                                            <p className={'' + (textOnBottom ? ' mt-1 ' : ' mld-2 ') + (textOnBottom ? " text-semibold font-size-13 " : ((!horizontal && perm.permissions) ? ' text-small text-bold ' : ' font-size-13 text-semibold'))}>{translate(perm.title)}</p>

                                        </button>


                                        {!this.props.permissionHeaders.hasAdvanced && perm.permissions && (
                                            <CollectionPermissionsView frame={this.props.frame} permissionHeaders={perm} changeAccess={this.props.changeAccess} admin={this.props.admin} permissionsObject={this.props.permissionsObject} fullAccessedClicked={this.props.fullAccessedClicked} type={this.props.type} stage={this.props.stage} previousHeaders={[...this.props.previousHeaders, permissionHeaders]} parentKey={fullKey} />
                                        )}
                                    </div>

                                )
                            })}
                        </div>

                        {this.props.permissionHeaders.hasAdvanced && (

                            <Collapsible open={this.state.showAdvanced}>
                                <div className='px-3 mt-1 pt-0' style={{ borderTop: '1px solid #eee', backgroundColor: "#fff" }}>

                                    <div className='flexc pt-0 mb-2 pb-2 ' >

                                        {Array.isArray(advancedTabs) && advancedTabs.map((tab, j) => {
                                            return (
                                                <div key={j} onClick={() => this.changeTabsView(tab.key)} className='d-flex flex-column mrd-4 cursor-pointer py-1' style={{ borderLeft: '0px solid #eee', color: tab.key == this.state.currentTab ? '#007aff' : '#000', borderBottom: tab.key == this.state.currentTab ? '2px solid #007aff' : '2px solid transparent' }}>
                                                    <p className=' mt-1 text-semibold' style={{ fontSize: 13 }}>{checkTranslation(tab.label)}</p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>

                                {this.state.currentTab == 'view' && (

                                    <div className='px-3'>
                                        <p className='mb-2 text-small text-semibold required'>{translate("Records to view")}</p>

                                        <div className='flexc bordered-input' style={{ maxWidth: 200 }}>

                                            <SelectInput data={(this.state.tabRecordsPermission?.value ? (typeof this.state.tabRecordsPermission?.value == 'object' ? "{}" : '*') : null)} changeValue={(key, value) => { this.props.changeAccess(frame, { key: 'records' }, value, [permissionHeaders, permissionHeaders[this.state.currentTab]?.permissions], this.state.currentTab) }} header={{ information: { items: [{ title: 'No record', value: null }, { title: 'All records', value: '*' }, { title: 'Specific Records', value: "{}" },], required: true } }} />
                                            {/* <RadiusSelectInput data={getPermissionObject(this.props.permissionsObject[id], 'view.records').value} header={{ information: { items: [{ title: 'No record', value: null }, { title: 'All records', value: '*' }, { title: 'Filtered Records', value: 'c' },] } }}
                                          changeValue={(key, value) => { this.props.changeAccess(frame, { key: 'view.records' }, value, headers) }}
                                    /> */}
                                        </div>

                                        {this.state.tabRecordsPermission?.value && this.state.tabRecordsPermission?.value != '*' && (
                                            <div>
                                                <p className='mb-2 text-small text-semibold required mt-3'>{translate("Condition of records")}</p>

                                                <div className='   br-4 ' style={{}}>
                                                    <FilterEditorInput data={this.state.tabRecordsPermission?.value} params={frame.fields} changeValue={(key, value, extra) => { this.props.changeAccess(frame, { key: 'records' }, value, [permissionHeaders, permissionHeaders[this.state.currentTab]?.permissions], this.state.currentTab) }} />
                                                </div>
                                            </div>
                                        )}


                                        {this.state.tabRecordsPermission?.value && (
                                            <>
                                                <div className='mt-3 '>
                                                    <p className='mb-2 text-small text-semibold required'>{translate("Fields to view")}</p>

                                                    <div className='flexc bordered-input' style={{ maxWidth: 200 }}>

                                                        <SelectInput data={(this.state.tabFieldsPermission?.value ? (Array.isArray(this.state.tabFieldsPermission?.value) ? "[]" : '*') : null)} header={{ information: { items: [{ title: 'All Fields', value: '*' }, { title: 'Specific Fields', value: '[]' },], required: true } }} changeValue={(key, value, extra) => { this.props.changeAccess(frame, { key: 'fields' }, value, [permissionHeaders, permissionHeaders[this.state.currentTab]?.permissions], this.state.currentTab) }} />

                                                    </div>

                                                </div>
                                                {this.state.tabFieldsPermission?.value != '*' && (
                                                    <div className='  mt-3 pb-2'>
                                                        <p className='mb-2 text-small text-semibold required'>{translate("Permitted fields to view")}</p>

                                                        <SelectListInput data={this.state.tabFieldsPermission?.value} header={{ information: { items: frame.fields, fields: { title: 'information.label', value: "key" }, multi: true, required: true } }} changeValue={(key, value, extra) => { this.props.changeAccess(frame, { key: 'fields' }, value, [permissionHeaders, permissionHeaders[this.state.currentTab]?.permissions], this.state.currentTab) }} />

                                                    </div>
                                                )}

                                            </>
                                        )}

                                    </div>

                                )}





                                {this.state.currentTab == 'edit' && (

                                    <div className='px-3'>
                                        <p className='mb-2 text-small text-semibold required'>{translate("Records to edit")}</p>

                                        <div className='flexc bordered-input' style={{ maxWidth: 200 }}>

                                            <SelectInput data={(this.state.tabRecordsPermission?.value ? (typeof this.state.tabRecordsPermission?.value == 'object' ? "{}" : '*') : null)} changeValue={(key, value) => { this.props.changeAccess(frame, { key: 'records' }, value, [permissionHeaders, permissionHeaders[this.state.currentTab]?.permissions], this.state.currentTab) }} header={{ information: { items: [{ title: 'No record', value: null }, { title: 'All viewable records', value: '*' }, { title: 'Specific Records', value: "{}" },], required: true } }} />

                                        </div>

                                        {this.state.tabRecordsPermission?.value && this.state.tabRecordsPermission?.value != '*' && (
                                            <div>
                                                <p className='mb-2 text-small text-semibold required mt-3'>{translate("Condition of records")}</p>

                                                <div className='   br-4 ' style={{}}>
                                                    <FilterEditorInput data={this.state.tabRecordsPermission?.value} params={frame.fields} changeValue={(key, value, extra) => { this.props.changeAccess(frame, { key: 'records' }, value, [permissionHeaders, permissionHeaders[this.state.currentTab]?.permissions], this.state.currentTab) }} />
                                                </div>
                                            </div>
                                        )}


                                        {this.state.tabRecordsPermission?.value && (
                                            <>
                                                <div className='  mt-3 '>
                                                    <p className='mb-2 text-small text-semibold required'>{translate("Fields to edit")}</p>

                                                    <div className='flexc bordered-input' style={{ maxWidth: 200 }}>

                                                        <SelectInput data={(this.state.tabFieldsPermission?.value ? (Array.isArray(this.state.tabFieldsPermission?.value) ? "[]" : '*') : null)} header={{ information: { items: [{ title: 'All viewable Fields', value: '*' }, { title: 'Specific Fields', value: '[]' },], required: true } }} changeValue={(key, value, extra) => { this.props.changeAccess(frame, { key: 'fields' }, value, [permissionHeaders, permissionHeaders[this.state.currentTab]?.permissions], this.state.currentTab) }} />

                                                    </div>

                                                </div>
                                                {this.state.tabFieldsPermission?.value != '*' && (
                                                    <div className='  mt-3 pb-2'>
                                                        <p className='mb-2 text-small text-semibold required'>{translate("Permitted fields to edit")}</p>
                                                        <SelectListInput data={this.state.tabFieldsPermission?.value} validOptions={((Array.isArray(this.state.viewFieldsPermission?.value) ? this.state.viewFieldsPermission?.value : null))} header={{ information: { items: frame.fields, fields: { title: 'information.label', value: "key" }, multi: true, invalidError: '{{lang}}This field can not become editable because it is not viewable', required: true } }} changeValue={(key, value, extra) => { this.props.changeAccess(frame, { key: 'fields' }, value, [permissionHeaders, permissionHeaders[this.state.currentTab]?.permissions], this.state.currentTab) }} />

                                                    </div>
                                                )}

                                            </>
                                        )}

                                    </div>

                                )}





                                {this.state.currentTab == 'remove' && (

                                    <div className='px-3'>
                                        <p className='mb-2 text-small text-semibold required'>{translate("Records to remove")}</p>

                                        <div className='flexc bordered-input' style={{ maxWidth: 200 }}>

                                            <SelectInput data={(this.state.tabRecordsPermission?.value ? (typeof this.state.tabRecordsPermission?.value == 'object' ? "{}" : '*') : null)} changeValue={(key, value) => { this.props.changeAccess(frame, { key: 'records' }, value, [permissionHeaders, this.state.removeHeaders], this.state.currentTab) }} header={{ information: { items: [{ title: 'No record', value: null }, { title: 'All viewable records', value: '*' }, { title: 'Specific Records', value: "{}" },], required: true } }} />

                                        </div>

                                        {this.state.tabRecordsPermission?.value && this.state.tabRecordsPermission?.value != '*' && (
                                            <div>
                                                <p className='mb-2 text-small text-semibold required mt-3'>{translate("Condition of records")}</p>

                                                <div className='   br-4 ' style={{}}>
                                                    <FilterEditorInput data={this.state.tabRecordsPermission?.value} params={frame.fields} changeValue={(key, value, extra) => { this.props.changeAccess(frame, { key: 'records' }, value, [permissionHeaders, this.state.removeHeaders], this.state.currentTab) }} />
                                                </div>
                                            </div>
                                        )}


                                    </div>

                                )}





                                {this.state.currentTab == 'manage' && (

                                    <div className='px-3'>
                                        {/* <p className='mb-2 text-small text-semibold required'>{translate("Records to remove")}</p> */}

                                        <CollectionPermissionsView frame={this.props.frame} permissionHeaders={permissionHeaders.manage} changeAccess={this.props.changeAccess} admin={this.props.admin} permissionsObject={this.props.permissionsObject} fullAccessedClicked={this.props.fullAccessedClicked} type={this.props.type} stage={this.props.stage} previousHeaders={[...this.props.previousHeaders, permissionHeaders]} parentKey={this.props.parentKey ? (this.props.parentKey + `.${this.state.currentTab}`) : this.state.currentTab} />

                                        {/* {permissionHeaders?.manage && Object.values(permissionHeaders.manage).map((perm, index) => {

                                            let fullKey = this.props.parentKey ? (this.props.parentKey + `.${this.state.currentTab}`) : this.state.currentTab

                                            console.log(fullKey)
                                            console.log(perm)
                                            console.log(permissionHeaders.manage)

                                            return (


                                                <div className='mb-3 pb-2' style={{ borderBottom: '1px solid #f2f2f2' }}>
                                                    <button className='flexc  ' style={{ marginBottom: 10 }} onClick={() => {
                                                        this.props.changeAccess(frame, { key: header.key }, (permissionStatus1.value == '*' ? null : '*'), [permissionHeaders, this.state.manageHeaders], `${this.state.currentTab}`)
                                                    }}>

                                                        <div className={"checkbox-container position-relative " + ((permissionStatus1.value && permissionStatus1.value != '*') ? 'half-mark' : '')}  >
                                                            <input type="checkbox" checked={permissionStatus1.allowed} />
                                                            <span className="checkmark"></span>
                                                            <div style={{}} className='position-absolute top-0 left-0 w-100 h-100'>
                                                            </div>
                                                        </div>
                                                        <p className=' mld-2 text-small text-bold'>{translate(header.title)}</p>

                                                    </button>

                                                    <div className={'' + (header.horizontal ? 'flexc' : '')}>

                                                        {Object.values(header.permissions).map((permission, j) => {

                                                            let permissionStatus = getPermissionObject(framePermission, `${this.state.currentTab}.${header.key}.${permission.key}`)

                                                            return (
                                                                <button className={'flexc mb-2 ' + (header.horizontal ? 'mrd-4' : '')} onClick={() => {
                                                                    this.props.changeAccess(frame, { key: permission.key }, (permissionStatus.value == '*' ? null : '*'), [permissionHeaders, this.state.manageHeaders, header.permissions], `${this.state.currentTab}.${header.key}`)
                                                                }}>

                                                                    <div className={"checkbox-container position-relative " + ((permissionStatus.value && permissionStatus.value != '*') ? 'half-mark' : '')}  >
                                                                        <input type="checkbox" checked={permissionStatus.allowed} />
                                                                        <span className="checkmark"></span>
                                                                        <div style={{}} className='position-absolute top-0 left-0 w-100 h-100'>
                                                                        </div>
                                                                    </div>
                                                                    <p className='mld-2 font-size-13 text-semibold'>{translate(permission.title)}</p>
                                                                </button>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            )
                                        })} */}

                                    </div>

                                )}






                                {/* {this.props.permissionsObject && Object.values(this.props.permissionsObject).map((permission, index) => {
                                                    let hasPermission = false
                                                    let thisPermission = this.state[this.state.currentType][this.props.currentItemIndex]?.permissions
                                                    if (typeof thisPermission == 'object') {
                                                        hasPermission = thisPermission[permission.key]
                                                    }
                                                    if (thisPermission == '*') {
                                                        hasPermission = true
                                                    }

                                                    return (
                                                        <div className='flexcb pt-2 pb-2 ' style={{ borderBottom: '0px solid #f6f6f6' }}>
                                                            <p className='text-small '>{checkTranslation(permission.label)}</p>
                                                            <SwitchInput data={hasPermission} header={{ key: permission.key, information: { size: 'small', } }} changeValue={this.changePermission} extra={{ type: 'admin', index: this.props.currentItemIndex }} />
                                                        </div>
                                                    )
                                                })} */}

                            </Collapsible>

                        )}

                        {this.props.permissionHeaders.hasAdvanced && (
                            <div className='px-3 pt-1 mb-2' style={{}}>
                                <p className='text-smaller mb-1 cursor-pointer' onClick={() => this.toggleAdvanced()} style={{ color: "#007aff" }} >{this.state.showAdvanced ? translate("Hide advance options") : translate("Show advance options")}</p>
                            </div>
                        )}

                    </div>

                )}


            </>

        )
    }
}

export default CollectionPermissionsView


// const mapStateToProps = state => ({ settings: state.settings, user: state.user })
// const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(PermissionsSidebarView);
